import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import UsersService from "@velocity-ehs/user-utils-module";
import { useInfiniteQuery } from "@tanstack/react-query";
import GatewayService from "../services/GatewayService";
import { useEffect } from "react";

function useInfiniteGetUsersAssignedToRole(roleID: string, location?: string) {
  const { showSnackbar } = useSnackbarActionContext();

  const result = useInfiniteQuery({
    queryKey: ["infiniteUsersAssignedToRole", location, roleID],
    queryFn: async ({ pageParam = 1 }) => {
      return await GatewayService.getUsersAssignedToRole(
        {
          and: {
            customerID: UsersService.customer.id,
            locationID: location,
            roleID: roleID,
          },
        },
        {
          pageNumber: pageParam,
          pageSize: 1000,
        }
      );
    },
    retry: false,
    enabled: !!location && !!roleID,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
    getNextPageParam: (lastPage: any) => {
      return lastPage.pageInfo.hasNext
        ? lastPage.pageInfo.pageNumber + 1
        : undefined;
    },
  });

  useEffect(() => {
    if (!result.isFetching && result.hasNextPage) {
      result.fetchNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result.isFetching, result.hasNextPage]);

  if (result.hasNextPage || !result.data?.pages) {
    return { ...result, isFetching: true, usersAssignedToRole: [] };
  }

  return {
    ...result,
    usersAssignedToRole: combineItems(result.data.pages),
  };
}

function combineItems(pages: Array<any>) {
  return pages.reduce((combined, current) => {
    return combined.concat(current.items);
  }, []);
}

export { useInfiniteGetUsersAssignedToRole };
